"use client";

import { useState } from "react";
import DemoCheckbox from "@/components/preview/demo-checkbox";
import DemoFooter from "@/components/preview/demo-footer";
import DemoWrapper from "@/components/preview/demo-wrapper";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export default function AccessibilityPointerEventsDemo() {
  const [passThrough, setPassThrough] = useState(false);
  const [presses, setPresses] = useState(0);

  return (
    <DemoWrapper margin="">
      <DemoFooter position="top">
        <DemoCheckbox
          checked={passThrough}
          label="pointer-events: none on the glow"
          onCheckedChange={setPassThrough}
        />
      </DemoFooter>

      <div className="flex h-44 w-full flex-col items-center justify-center gap-5">
        <div className="relative">
          <Button
            onClick={() => setPresses((count) => count + 1)}
            rounded
            size="md"
            type="button"
            variant="secondary"
          >
            Save changes
          </Button>
          <div
            aria-hidden="true"
            className={cn(
              "absolute -top-9 -right-12 size-24 rounded-full border border-sky-400 border-dashed",
              passThrough && "pointer-events-none"
            )}
          >
            <div className="size-full rounded-full bg-sky-400/25 blur-lg" />
          </div>
        </div>
        <p className="select-none text-gray-1000 text-sm tabular-nums">
          Presses: {presses}
        </p>
      </div>
    </DemoWrapper>
  );
}
